import { makeStyles, tokens } from '@coreai/fluentui-react';
import { PlayFilled } from '@fluentui/react-icons';

const useStyles = makeStyles({
  root: {
    width: '24px',
    height: '24px',
    borderRadius: tokens.borderRadiusSmall,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  fallback: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForegroundOnBrand,
  },
});

type ConnectorBrandIconProps = {
  brandColor: string;
  iconUri?: string | undefined;
};

/**
 * Square brand-color tile with the connector's icon (or a play-icon fallback).
 * Shared between `ConnectorSection` and `AzureConnectorSection` headers.
 */
export const ConnectorBrandIcon = ({ brandColor, iconUri }: ConnectorBrandIconProps) => {
  const styles = useStyles();
  return (
    <div className={styles.root} style={{ backgroundColor: brandColor }}>
      {iconUri ? (
        <img
          src={iconUri}
          alt=""
          className={styles.image}
          loading="lazy"
          decoding="async"
        />
      ) : (
        <PlayFilled className={styles.fallback} />
      )}
    </div>
  );
};

export default ConnectorBrandIcon;
